<template>
  <aside class="dd-effects__sidebar">
    <slot></slot>
  </aside>
</template>

<script>
export default {
  name: 'EffectSummarySidebar',
};
</script>
